export const API_URL = 'https://api.ahmadsadek.com/';
export const BASE_URL = 'https://dev.ahmadsadek.com/';

export const apiCall = async (method, path, data) => {
    const body = method !== 'GET' ? JSON.stringify(data) : null;

    const response = await fetch(API_URL + 'api' + path, {
        method,
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${data?.token}`
        },
        body
    }).then(res => res.json()).catch(err => console.log(err));

    return response;
}
